// extracted by mini-css-extract-plugin
export default {"myTabs":"tabs_myTabs__SvAPo","badge":"tabs_badge__aYsAj","badge-yellow":"tabs_badge-yellow__6EcHL","badge-green":"tabs_badge-green__lfFlQ","badge-red":"tabs_badge-red__wsbfq"};